//App.js
import React, { useState } from 'react';
import './App.scss';
import ChatWindow from './components/ChatWindow.js';
import InputForm from './components/InputForm.js';
import SuggestedPrompts from './components/SuggestedPrompts.js';
import { fetchGeneratedResponse } from './utils/api.js';
import { isValidUrl } from './utils/utils.js';
import appLogo from './assets/logo.png';

const App = () => {
  const [messages, setMessages] = useState([]);
  const [submitCounter, setSubmitCounter] = useState(0);
  const [validationMessage, setValidationMessage] = useState('');
  const [isFetching, setIsFetching] = useState(false);
  const [context, setContext] = useState(null);
  const handleResetSubmitCounter = () => {
    setSubmitCounter(0);
    setMessages([]);
    setValidationMessage('');
  };

  const handleSubmit = async (input) => {
    if (submitCounter < 1 && !isValidUrl(input)) {
      setValidationMessage('This is not a valid URL. Provide a valid URL to continue.');
      return;
    } else {
      setValidationMessage('');
    }

    setSubmitCounter((prevCounter) => prevCounter + 1);
    setIsFetching(true);
    let userMessageText = submitCounter === 0 ? `Explain the top privacy policy concerns of ${input}` : input;

    const userMessage = { sender: 'You', text: userMessageText };
    setMessages((prevMessages) => [...prevMessages, userMessage]);

    const { response, newContext } = await fetchGeneratedResponse(input, submitCounter > 0, context);

    setContext(newContext);
    setIsFetching(false);

    const generatedResponse = {
      sender: 'PrivacyGPT',
      text: response || 'Failed to generate a response.',
    };

    setMessages((prevMessages) => [...prevMessages, generatedResponse]);
  };

  return (
      <div className="privacy-clarity-app-inner">
        <div className="pc-chat">
          <img className="pc-app-logo" width="512" height="114" src={appLogo} alt="Logo of PrivacyClarity GPT" />
          <div className="sub-title">
            Reveal the top privacy concerns of any website's privacy policy
          </div>
          <InputForm onSubmit={handleSubmit} submitCounter={submitCounter} validationMessage={validationMessage} setValidationMessage={setValidationMessage} />
          {submitCounter > 0 && <ChatWindow messages={messages} submitCounter={submitCounter} isFetching={isFetching} />}
          {!isFetching && <SuggestedPrompts onClick={handleSubmit} onResetSubmitCounter={handleResetSubmitCounter} submitCounter={submitCounter} />}
        </div>
      </div>
  );
};

export default App;
